<!-- TODO: ugly hack-->
@if (!checkCookiesConsent() && ('COOKIES.BANNER' | translate) !== 'COOKIES.BANNER') {
  <div class="cookie-banner">
    <div class="cookie-banner__content">
      {{ 'COOKIES.BANNER' | translate }}
      <button (click)="consentCookie()" color="primary" mat-flat-button>
        {{ 'COOKIES.BANNER_ACCEPT' | translate }}
      </button>
    </div>
  </div>
}
